var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    fill: "none",
    stroke: "#0000f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 58.562A28.979 28.979 0 1030 59M30 36a6 6 0 113.784-1.343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.82 32H46v-4h-4.18a11.92 11.92 0 00-2.046-4.946l2.954-2.954-2.829-2.828-2.954 2.954A11.92 11.92 0 0032 18.18V14h-4v4.18a11.92 11.92 0 00-4.946 2.046l-2.953-2.954-2.829 2.828 2.954 2.954A11.92 11.92 0 0018.18 28H14v4h4.18a11.92 11.92 0 002.046 4.946L17.272 39.9l2.829 2.828 2.954-2.954A11.92 11.92 0 0028 41.82V46h4v-4.18a11.92 11.92 0 004.946-2.046l2.954 2.954 2.828-2.829-2.954-2.953"
  })))));
}
export default SvgSettings;